import { createContext, useContext } from 'react';

export interface SocketContextType {
  isConnected: boolean;
  isConnecting: boolean;
  lastError: string | null;
  emit: (event: string, payload?: unknown) => boolean;
  on: (event: string, listener: (payload: unknown) => void) => () => void;
}

export const SocketContext = createContext<SocketContextType | undefined>(
  undefined
);

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket doit etre utilise dans un SocketProvider');
  }
  return context;
};
